import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    w-32
  `,
  slots: {
    button: `
      p-3
      [&:first-child]:pr-2
      [&:last-child]:pl-2
    `,
    icon: `
      h-5
      w-5
      p-0
    `,
    input: `
      h-11
      rounded
      text-center
      align-middle
      [appearance:textfield]
      [&::-webkit-inner-spin-button]:appearance-none
      [&::-webkit-outer-spin-button]:appearance-none
    `,
  },
});
